<template>
    <div class="food-detail-wrapper">
        <div class="swiper-wrapper" v-if="detailData.image">
            <van-swipe
                :autoplay="3000"
                class="swiper-container"
                :width="swipeWidth"
                @change="onSwipeChange"
                v-show="detailData.image.length>0"
            >
                <van-swipe-item v-for="(image,index) in detailData.image" :key="index">
                    <img v-lazy="image.url">
                </van-swipe-item>
                <template slot="indicator">
                    <div class="custom-indicator">{{ currentSwipe + 1 }}/{{detailData.image.length}}</div>
                </template>
            </van-swipe>
        </div>
        <div class="detail-wrapper">
            <div class="title-text" v-text="detailData.name"></div>
            <div class="rate-row">
                <star :score="detailData.level" shape="laud"></star>
                <div class="ave-price" v-cloak>￥{{detailData.avgSpend}}/人</div>
            </div>
            <div class="tags">
                <div class="tag" v-for="(tag,i) of detailData.tags" :key="i" v-text="tag"></div>
            </div>
            <div class="info first-child">
                <span>
                    <span class="title">电话</span>
                    <a class="telephone" :href="'tel:'+detailData.tel" v-text="detailData.tel"></a>
                </span>
            </div>
            <div class="info" @click.stop="openMap">
                <span class="wra">
                    <span class="title">地址</span>
                    <span class="address" v-text="detailData.address"></span>
                </span>
                <img
                    src="https://oss.tuoxingwang.com/vaporetto-assets/scene/png/location-icon.png"
                    alt="location-icon"
                    class="address-icon"
                >
            </div>
        </div>

        <food-detail-item @openmodal="openModal" :food-data="detailData.list" :title="{text:'代金券'}"></food-detail-item>

        <div class="content-wra" v-if="detailData.dish&&detailData.dish.length>0">
            <div class="title">
                <span class="text">特色菜品</span>
                <span class="right" @click="redirectToFoodFeature" v-cloak>
                    <span class="right-text" v-cloak>全部{{detailData.dish.length}}种菜品</span>
                    <img src="https://oss.tuoxingwang.com/vaporetto-assets/scene/png/right-icon-blue.png" alt>
                </span>
            </div>
            <ul class="caipin-wra no-scrollbar">
                <li
                    class="each-caipin"
                    v-for="(item, index) in detailData.dish.slice(0,7)"
                    :key="index"
                >
                    <img class="caipin-image" @error="__change__no__image" :src="item.imageUrl">
                    <span class="caipin-name" v-text="item.name"></span>
                    <span class="price" v-cloak>￥{{item.price}}</span>
                </li>
            </ul>
        </div>

        <div class="content-wra">
            <div class="title">
                <span class="text">详细介绍</span>
            </div>
            <div
                class="caipin-detail rich-context-wra protect-image"
                v-html="detailData.introduction||'无'"
            ></div>
        </div>

        <voucher-intro-modal
            :intro-data="currentIntroData"
            ref="modal"
            :title="currentIntroData.name"
            :is-show-bottom="true"
        ></voucher-intro-modal>
    </div>
</template>

<script>
import VoucherIntroModal from "@/components/VoucherIntroModal";
import FoodDetailItem from "@/components/FoodDetailItem";
import Star from "@/components/common/Star.vue";
export default {
    name: "FoodDetail",
    components: { Star, FoodDetailItem, VoucherIntroModal },
    props: {
        // layouts: String,
        // layoutType: String,
    },
    data() {
        return {
            currentSwipe: 0,
            currentIntroData: {},
            detailData: {},
            swipeWidth: window.innerWidth,
            isWXSharePage: true
        };
    },
    computed: {},
    watch: {},
    activated() {
        this.isWXSharePage = true;
        this.getFoodDetailData();
        this.currentSwipe = 0;
    },
    deactivated() {
        this.isWXSharePage = false;
        this.$refs.modal.closeModal();
    },
    mounted() {},
    destroyed() {},
    methods: {
        onSwipeChange(index) {
            this.currentSwipe = index;
        },
        openMap() {
            UTILS.openMap(this.detailData);
        },
        redirectToBuy() {},
        openModal(detail) {
            this.currentIntroData = detail;
            this.$nextTick(() => {
                this.$refs.modal.openModal();
            });
        },
        closeModal() {
            this.$refs.modal.closeModal();
        },
        redirectToFoodFeature(foodId) {
            sessionStorage.specialFoods = JSON.stringify(this.detailData.dish);
            this.$router.push({ name: "foodFeature" });
        },
        getFoodDetailData() {
            this.$axios
                .get(`${window.API.food.detail}/${this.$route.params.foodId}`)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.detailData = data.data;
                        //设置微信分享
                        if (
                            this.isWXSharePage &&
                            sessionStorage.getItem("title") !==
                                `${API.projectName}-${data.data.name}`
                        ) {
                            this.isWXSharePage = false;
                            window.global.getConfig({
                                title: `${API.projectName}-${data.data.name}`,
                                link: `${window.location.origin}?shareto=${
                                    this.$route.name
                                }&shareid=${this.$route.params.foodId}`,
                                imgUrl: `${
                                    data.data.thumbnail
                                        ? data.data.thumbnail +
                                          "?x-oss-process=image/resize,m_fill,h_256,w_256"
                                        : ""
                                }`,
                                desc: ``
                            });
                        }
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>

<style scoped lang="scss">
.food-detail-wrapper {
    background: #f0f0f0;
    .swiper-wrapper {
        height: 6rem;
        .swiper-container {
            height: 100%;
        }
    }
    .detail-wrapper {
        padding: 0.44rem 0.333333rem 0.44rem 0.533333rem;
        background: $white;
        .title-text {
            font-weight: bold;
            color: #484848;
            font-size: 23px;
            word-wrap: break-word;
            .star-tag {
                width: 0.746667rem;
                height: 0.4rem;
                line-height: 0.4rem;
                text-align: center;
                background: $blue;
                border-radius: 2px;
                color: $white;
                margin-left: 0.346667rem;
                font-size: 11px;
                display: inline-block;
                vertical-align: sub;
            }
            .play-button {
                font-size: 13px;
                color: #404040;
                .right-icon {
                    width: 0.16rem;
                    margin-left: 0.173333rem;
                }
            }
        }
        .rate-row {
            margin-top: 0.226667rem;
            display: flex;
            align-items: center;
            .ave-price {
                font-size: 13px;
                color: $grey4;
                margin-left: 0.24rem;
            }
        }
        .tags {
            width: 100%;
            display: flex;
            margin-top: 0.266667rem;
            margin-bottom: 0.333333rem;
            flex-wrap: wrap;
            .tag {
                padding: 0.05rem 0.14rem;
                color: $blue;
                border: 1px solid $blue;
                background: $white;
                margin-right: 0.133333rem;
                font-size: 0.293333rem;
                border-radius: 0.106667rem;
                flex: 0 0 auto;
            }
        }
        .info {
            width: 100%;
            display: flex;
            justify-content: space-between;
            font-size: 13px;
            margin-bottom: 0.346667rem;
            &:last-child {
                margin-bottom: 0px;
            }
            &.first-child {
                padding-top: 0.333333rem;
                border-top: 1px solid #f0f0f0;
            }
            .wra {
                width: 95%;
                display: flex;
                align-items: center;
            }
            .title {
                color: #404040;
                font-weight: bold;
                padding-right: 0.293333rem;
            }
            .telephone {
                color: $blue;
                font-size: 13px;
                text-decoration: none;
            }
            .address {
                display: inline-block;
                font-size: 13px;
                color: #808080;
                max-width: 85%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .address-icon {
                width: 0.333333rem;
                height: 0.4rem;
            }
        }
    }
    .content-wra {
        padding: 0.466667rem 0;
        background: $white;
        margin-top: 0.213333rem;
        .title {
            display: flex;
            align-items: center;
            margin-bottom: 0.493333rem;
            padding: 0 0.4rem;
            justify-content: space-between;
            .text {
                color: #404040;
                font-size: 18px;
            }
            .right {
                color: $blue;
                font-size: 13px;

                display: flex;
                align-items: center;
                .right-text {
                    margin-right: 0.226667rem;
                }
                img {
                    width: 0.16rem;
                    height: 0.266667rem;
                }
            }
        }
        .caipin-wra {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            padding-left: 0.133333rem;

            .each-caipin {
                flex: none;
                display: flex;
                flex-direction: column;
                margin-left: 0.266667rem;
                .caipin-image {
                    width: 2.4rem;
                    height: 2.4rem;
                    border-radius: 5px;
                }
                .caipin-name {
                    font-size: 14px;
                    color: #333333;
                    margin: 0.32rem 0 0.133333rem;
                }
                .price {
                    font-size: 15px;
                    color: #ffb300;
                }
            }
        }
        .caipin-detail {
            padding: 0 0.4rem;
        }
    }
}
</style>



